import usePricing from '@components/cms-components/pricing/pricing.hook';
import Pricing from 'features/pricing';
import type { ReactElement } from 'react';
import React from 'react';
import type { PricingData } from 'types/components/pricing';
import type { DataProps } from 'types/props/data-props';
import { validateString } from 'utils/validate-string';

import styles from './pricing.module.scss';

const disclaimerClass = validateString(styles.disclaimer);

export default function PricingComponent({
  disclaimer,
  services,
}: DataProps<PricingData>): ReactElement {
  const { prices } = usePricing({ services });
  return (
    <div>
      <p className={disclaimerClass}>{disclaimer}</p>
      <Pricing pricing={prices} />
    </div>
  );
}
